module.exports = __webpack_public_path__ + "static/media/monster-05.f02ddf16.png";